import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionProps {
  question: string;
  answer: string;
}
export const Accordion: React.FC<AccordionProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-2xl mb-4 overflow-hidden bg-white shadow-sm transition-all duration-300 hover:shadow-md" data-id="element-1">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-2">
        <span className="font-semibold text-gray-900 text-lg pr-4" data-id="element-3">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-6 h-6 text-[#008080] flex-shrink-0" data-id="element-4" /> : <ChevronDown className="w-6 h-6 text-[#008080] flex-shrink-0" data-id="element-5" />}
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-6">
        <div className="px-6 pb-6 text-gray-600 leading-relaxed text-lg" data-id="element-7">
          {answer}
        </div>
      </div>
    </div>;
};